import { IEventMetadata, IFormFieldMetadata, IFormFieldValueMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ITrial, ResponseStatus } from "@/api/dtos";
import { ISourceDataFormLayoutComponents, ISourceDataFormSettings, ISourceDataVerificationEvent, ISourceDataVerificationItem } from "@/utilities/forms/SourceDataFormProcessor";
import { Observable } from "@ngt/forms-core";
import { createContext } from "react"

export interface ISourceDataExpandingContext { 
    toggleExpanding: (identifier: string) => void;
    expanded: Record<string, boolean>;
}

export const SourceDataExpandingContext = createContext<ISourceDataExpandingContext>({
    toggleExpanding: () => {},
    expanded: {}
});

export default SourceDataExpandingContext;